'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BILLING_WRITE: 'billing-write',

  PARTNER_LEAD_REGISTRATION: 'partner-lead-registration',
  DIRECTORY_USER: 'partner-join-program'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/Scopes.js
// module id = 236
// module chunks = 3 4 5